import {
  CourseEntity,
  Enum_Favorite_Type,
  InsightEntity,
  PodcastEntity,
  ResourceEntity,
} from '@/graphql/generated/graphql';

import FavoriteButton from '../Favorite/FavoriteButton';
import LikeButton from '../LikeButton';

type LikeAndFavoriteProps = {
  entity: ResourceEntity | PodcastEntity | InsightEntity | CourseEntity;
  entityId: string;
  like?: boolean;
  favorite?: boolean;
  type: Enum_Favorite_Type;
};

export default function LikeAndFavorite({
  like = true,
  favorite = true,
  entity,
  entityId,
  type,
}: LikeAndFavoriteProps) {
  return (
    <div className="flex items-start justify-between gap-2">
      <div className="flex gap-sh-15">
        <div className="flex items-center justify-center">{like && <LikeButton entityId={entityId} type={type} />}</div>
        <div>{favorite && <FavoriteButton relationId={entityId || ''} metadata={entity!} type={type} />}</div>
      </div>
    </div>
  );
}
